import { Board as BoardRoot } from "./Board";
import { BoardColumn } from "./BoardColumn";
import { BoardCard } from "./BoardCard";
import { BoardDragOverlay } from "./BoardDragOverlay";
import { BoardEmptyColumn } from "./BoardEmptyColumn";
import { BoardMinimap } from "./BoardMinimap";

export const Board = Object.assign(BoardRoot, {
  Column: BoardColumn,
  Card: BoardCard,
  DragOverlay: BoardDragOverlay,
  EmptyColumn: BoardEmptyColumn,
  Minimap: BoardMinimap,
});

export type {
  BoardProps,
  BoardColumnProps,
  BoardCardProps,
  MinimapColumnMeta,
  BoardMinimapProps,
} from "./types";
export { useBoardDragHandlers } from "./useBoardDragHandlers";
export type { ColumnData, BoardDragResult } from "./useBoardDragHandlers";
